import React from 'react';
import { ArrowRightIcon, RocketIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://kit-instrumentacion-industrial.impultienda.ar/checkout';
interface CtaButtonProps {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
  /** Defaults to scrolling to the offer section; pass CHECKOUT_URL to go straight to payment. */
  href?: string;
  /** 'copper' works on light backgrounds, 'gold' on the dark offer card. */
  variant?: 'copper' | 'gold';
  fullWidth?: boolean;
  /** Identifies which CTA on the page was clicked, sent to the Meta Pixel. */
  source?: string;
}
export function CtaButton({
  label = 'Quiero Mi Kit Ahora',
  size = 'lg',
  className = '',
  href = '#oferta',
  variant = 'copper',
  fullWidth = false,
  source = 'cta'
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  const sizing = size === 'lg' ? 'px-9 py-4 text-lg' : 'px-6 py-3 text-base';
  const tone = variant === 'gold' ? 'bg-ember-400 text-forest-900 hover:bg-[#F2B653] focus-visible:outline-ember-400' : 'bg-ember-500 text-white hover:bg-ember-600 focus-visible:outline-ember-500';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Kit Instrumentación Industrial',
      content_category: source,
      value: 19,
      currency: 'USD'
    });
  };
  return <a href={href} onClick={handleClick} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-flex items-center justify-center gap-2.5 rounded-full font-semibold shadow-lift transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${sizing} ${tone} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-47" data-mp="3ow09ujfgrigj">
      {variant === 'gold' ? null : <RocketIcon className="h-5 w-5" aria-hidden="true" data-id="element-48" data-mp="gg89k95cpoy7" />}
      {label}
      {variant === 'gold' ? <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-49" data-mp="3mxgt489scfa8" /> : null}
    </a>;
}